import { useState, useEffect } from 'react'

import { Editor } from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/idea.css'

import { IEditor, EditorProps } from './@types'
import { EditorWrapper } from './Style'

function EditorComponent({ id, value, onChange, editorErrorList, readonly }: EditorProps) {
  const [editor, setEditor] = useState<IEditor>(null)

  const options = {
    mode: 'xml',
    theme: 'idea',
    lineNumbers: true,
    readOnly: readonly,
  }

  useEffect(() => {
    onErrorsChanges()
  }, [editorErrorList, value])

  const onEditorMount = (editor: Editor) => {
    setEditor(editor)
  }

  const handleOnChange = (editor: Editor, data: any, value: string) => {
    if (onChange) {
      onChange(value)
    }
  }

  const onErrorsChanges = () => {
    if (editorErrorList?.length === 0) {
      clearAllMarks()
    } else {
      clearAllMarks()
      editorErrorList?.forEach(({ line, lineLength }) => {
        highlightLines(line, lineLength + 10)
      })
      clearEmptyLines()
    }
  }

  const clearAllMarks = () => {
    editor?.getAllMarks().forEach((marker) => {
      marker.clear()
    })
  }

  const clearEmptyLines = () => {
    const doc = editor?.getDoc()
    if (doc) {
      for (let i = doc.lineCount() - 1; i >= 0; i--) {
        const lineText = doc.getLine(i)
        if (lineText.trim() === '') {
          doc.replaceRange('', { line: i, ch: 0 }, { line: i + 1, ch: 0 })
        }
      }
    }
  }

  const highlightLines = (line: number, length: number) => {
    if (editor) {
      editor.markText(
        { ch: 0, line },
        { ch: length, line },
        {
          className: 'error',
          clearOnEnter: false,
          addToHistory: true,
        },
      )
    }
  }

  return (
    <EditorWrapper
      id={id}
      value={value}
      options={options}
      autoCursor={false}
      editorDidMount={onEditorMount}
      onChange={handleOnChange}
    />
  )
}

export { EditorComponent }
